import styled from "styled-components";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import IconButton from "./IconButton";
import { ReactNode, useEffect, useState } from "react";

const CopyValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CopyTooltipIcon = styled.i`
  color: var(--aa-accent);
  margin-right: 5px;
`;

const CopyValueItem = styled.code`
  min-width: 0;
`;

const CopyValue = ({
  children,
  value,
}:
  | {
      children?: string;
      value?: string;
    }
  | {
      children?: ReactNode;
      value: string;
    }) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const copyTooltip = (
    <Tooltip style={{ position: "fixed" }}>
      <CopyTooltipIcon className="bi-clipboard-check-fill" />
      <span>Copied</span>
    </Tooltip>
  );

  useEffect(() => {
    if (showTooltip) {
      setTimeout(() => {
        setShowTooltip(false);
      }, 2000);
    }
  }, [showTooltip]);

  const copyValue = async () => {
    navigator.clipboard.writeText(
      value || (children && typeof children === "string" ? children : "")
    );
    setShowTooltip(true);
  };

  return (
    <CopyValueContainer>
      <CopyValueItem>{children}</CopyValueItem>
      <OverlayTrigger
        overlay={copyTooltip}
        show={showTooltip}
        placement="auto"
        rootClose
      >
        <div>
          <IconButton className={"bi-copy"} onClick={copyValue} />
        </div>
      </OverlayTrigger>
    </CopyValueContainer>
  );
};

export default CopyValue;
